import type { LinkProps } from '@mui/material/Link';

import Link from '@mui/material/Link';
import * as React from 'react';

export const LinkLikeText: React.FC<LinkProps> = React.memo(
    (props: LinkProps) => {
        return <Link {...props} variant="body2" style={{cursor: 'pointer'}} underline="hover" />;
    }
);